import PageHeading from "./PageHeading";
export default PageHeading;
